import { style } from "@vanilla-extract/css";
import { breakpoints, vars } from "plos/src/styles";

export const pitchControlsWrap = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: vars.space.xs,
  "@media": {
    [`screen and (min-width: ${breakpoints[3]})`]: {
      margin: `0 ${vars.space["3xl"]}`,
    },
  },
});

export const pitchViewToggle = style({
  width: 215,
});
